/**
 * @generated SignedSource<<b503f051f5b541c3fa5194b1c86680ad>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type usePublishModalActionsSchedulePublishInfoFragment$data = {
  readonly schedulePublishInfo: {
    readonly __typename: "SchedulePublishInfo";
    readonly date: string | null;
    readonly minorEdit: boolean | null;
    readonly targetType: string | null;
    readonly versionComment: string | null;
  } | null;
  readonly " $fragmentType": "usePublishModalActionsSchedulePublishInfoFragment";
};
export type usePublishModalActionsSchedulePublishInfoFragment$key = {
  readonly " $data"?: usePublishModalActionsSchedulePublishInfoFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePublishModalActionsSchedulePublishInfoFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "usePublishModalActionsSchedulePublishInfoFragment",
  "selections": [
    {
      "concreteType": "SchedulePublishInfo",
      "kind": "LinkedField",
      "name": "schedulePublishInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "date"
        },
        {
          "kind": "ScalarField",
          "name": "minorEdit"
        },
        {
          "kind": "ScalarField",
          "name": "targetType"
        },
        {
          "kind": "ScalarField",
          "name": "versionComment"
        },
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    }
  ],
  "type": "Content"
};

(node as any).hash = "5dc641b473052bf1fb2921bbc4960dcc";

export default node;
